import { createFileRoute } from '@tanstack/react-router';
import ReportIncidentPage from '../../../features/patient-transport/pages/ReportIncidentPage';

export const Route = createFileRoute('/_auth/patient-transport/fares/active/$id/report-incident')({
  component: RouteComponent,
});

function RouteComponent() {
  const { id: fareId } = Route.useParams();

  return <ReportIncidentPage fareId={fareId} />;
}
